export default __webpack_public_path__ + "static/media/speed-banners-cn.93bbe147.webp";